import React, {
  ChangeEvent, FC, useState, useEffect,
} from 'react';
import { useNavigate } from 'react-router-dom';
import Mixpanel from 'mixpanel-browser';
import QuizHeader from '~/components/QuizHeader';
import Input from '~/components/Input';
import Button from '~/components/Button';
import techEu from '~/assets/images/techEu.png';
import email from '~/assets/icons/Email.svg';
import emailError from '~/assets/icons/EmailError.svg';
import { NavigationPath, ScreenProps } from '~/core/dto/navigationDTO';
import Spacer from '~/components/Spacer';
import { validationEmail } from '~/core/helpers/internal';

import './Email.styles.css';

const Email: FC<ScreenProps> = ( { type } ) => {

  const navigate = useNavigate();
  const routeName = `Email-${type}`;

  const [ emailValue, setEmailValue ] = useState<string>();
  const [ invalidEmail, setInvalidEmail ] = useState( false );

  const onChange = ( e: ChangeEvent<HTMLInputElement> ) => {

    setInvalidEmail( false );
    setEmailValue( e.target.value );

  };

  const onSubmit = ( e: React.FormEvent<HTMLFormElement> ) => {

    e.preventDefault();

    if ( !emailValue || !validationEmail( emailValue ) ) {

      setInvalidEmail( true );

      return;

    }

    fetch( 'https://web.birdwingo.com/api/wolverine/v1/emails', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify( { email: emailValue, type: type.toUpperCase() } ),
    } ).catch( ( error ) => console.error( 'Error:', error ) );

    window.fbq( 'track', 'Lead', { value: emailValue } );

    window.ttq.identify( { email: emailValue } );
    window.ttq.track( 'CompleteRegistration', { contents: [ { content_id: emailValue, content_name: emailValue } ] } );

    Mixpanel.identify( emailValue );
    Mixpanel.track( routeName, { state: 1 } );

    navigate( type === 'adult' ? NavigationPath.AdultQuizResult : NavigationPath.GrowthPlan );

  };

  useEffect( () => {

    Mixpanel.track( routeName, { state: 0 } );

  }, [] );

  return (
    <div className="container">
      <QuizHeader type={type} onlyTitle />
      <div className="scrollContainer smallContainer">
        <h1 className="textCenter">
          <span className="primaryBroadbill">Achieve goals</span>
          &#160;together with Birdwingo
        </h1>
        <Spacer size={16} />
        <p className="textCenter">Enter your email to see your results</p>
        <Spacer size={24} />
        <form onSubmit={onSubmit} noValidate>
          <Input type="email" error={invalidEmail ? 'Invalid email' : ''} placeholder="Email" icon={invalidEmail ? emailError : email} required onChange={onChange} />
          <p className="emailDescription">
            By continuing you indicate that you’ve read and agree to our&#160;
            <a href="https://www.birdwingo.com/wp-content/uploads/2023/09/Birdwingo-TCs.pdf">Terms & Conditions</a>
            ,&#160;
            <a href="https://www.birdwingo.com/wp-content/uploads/2022/10/Birdwingo_Privacy-Policy-Updated.pdf">Privacy Policy</a>
            &#160;and to receive emails from Birdwingo
          </p>
          <Button isSubmit disabled={!emailValue}>Continue</Button>
        </form>
        <Spacer size={48} />
        <div className="emailBox flexColumn justifyCenter alignCenter">
          <h1 className="emailQuoationMarks primaryBroadbill">”</h1>
          <h2 className="textCenter">Birdwingo addresses the gap in financial education, which is not adequately covered by schools</h2>
          <img src={techEu} alt="TechEU" />
        </div>
        <Spacer size={16} />
      </div>
    </div>
  );

};

export default Email;
